// lib/coupon.ts
// LÀM GÌ? SSOT chuẩn hoá + kiểm định dạng mã giảm giá (client & server dùng chung)
// VÌ SAO? Lọc rác trước khi gọi DB, cùng 1 quy tắc ở modal và server action
// DB SCHEMA: coupons.code (UNIQUE upper(code))
// FILE NÀO DÙNG: actions/coupons.ts, actions/study.ts, components/shared/PurchaseConfirmModal.tsx
export const COUPON_CODE_RE = /^[A-Z0-9][A-Z0-9-]{2,31}$/;

// Bỏ ký tự dễ nhầm (0/O, 1/I/L) → user đọc mã từ mail/ảnh không gõ sai
const CODE_ALPHABET = "ABCDEFGHJKMNPQRSTUVWXYZ23456789";

/** Sinh mã ngẫu nhiên dạng JB-XXXX-XXXX (~10^12 tổ hợp, không dò được) */
export function generateCouponCode(prefix = "JB"): string {
  const buf = new Uint32Array(8);
  crypto.getRandomValues(buf);
  const s = Array.from(buf, (n) => CODE_ALPHABET[n % CODE_ALPHABET.length]).join("");
  return `${prefix}-${s.slice(0, 4)}-${s.slice(4)}`;
}

export function normalizeCouponCode(raw: unknown): string | null {
  if (typeof raw !== "string") return null;
  const code = raw.trim().toUpperCase();
  return COUPON_CODE_RE.test(code) ? code : null;
}